export default "__VITE_ASSET__CaxbRoMY__"